var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLineNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1235,
    height: 491,
    viewBox: "0 0 1235 491",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M331 395.001C293.625 459.872 105.678 539.087 1 395",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1234 395C1201.74 460.672 1030.36 540.866 940 395.001",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M832.5 95.8861C774.816 30.5822 595.559 -50.6601 434 94.3877",
    stroke: "#FDFDFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2265_19333",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 462,
    width: 27,
    height: 27
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.997 465.117L148.727 488.961L172.571 486.232L169.841 462.387L145.997 465.117Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2265_19333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.053 466.005L164.641 473.907C165.369 474.451 165.488 475.495 164.902 476.189L156.373 486.279C155.732 487.037 154.496 486.663 154.383 485.677L152.25 467.042C152.137 466.056 153.257 465.411 154.053 466.005Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M614.692 2.58166L623.356 12.5573C623.952 13.2431 623.845 14.2889 623.124 14.8419L612.644 22.8849C611.856 23.4892 610.727 22.8602 610.827 21.8725L612.71 3.21066C612.81 2.22291 614.041 1.83217 614.692 2.58166Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2265_19333",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1066,
    y: 463,
    width: 28,
    height: 28
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1066 466.938L1069.94 490.613L1093.61 486.675L1089.67 463L1066 466.938Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2265_19333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1074.09 467.417L1085.06 474.77C1085.82 475.276 1085.99 476.313 1085.44 477.035L1077.43 487.547C1076.83 488.336 1075.58 488.025 1075.42 487.046L1072.34 468.544C1072.17 467.564 1073.26 466.864 1074.09 467.417Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLineNew);
export default __webpack_public_path__ + "static/media/arrow_line_new.93cc52ba27aecbab902bae0e1d8fc098.svg";
export { ForwardRef as ReactComponent };